<div class="flex flex-row justify-between mt-4">
  <div class="flex flex-row mat-headline-6 items-center">
    <mat-icon svgIcon="summarize" class="mr-4"></mat-icon>
    <div>{{'INSTANCE_DETAILS.OVERVIEW' | transloco }}</div>
  </div>
  <div class="flex flex-row">
    <span class="circle mr-30">
      <mat-icon svgIcon="refresh" class="icon-md mt-2 mr-10 cursor-pointer" [@rotate]="count" (@rotate.done)="count > 1" (click)="onRefreshClick();"></mat-icon>
    </span>
  </div>
</div>
<mat-divider class="neutral-2 mb-8 ml-6 mr-6"></mat-divider>
<div class="m-4 p-24">
  <div class="mat-subtitle-2 fw-700 fs-18">{{'INSTANCE_DETAILS.GENERAL' | transloco }}</div>
  <mat-divider class="neutral-2 mt-12"></mat-divider>
  <div>
    <div class="flex flex-row grid-flow-col">
      <div class="left-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.SOLUTION' | transloco }}</div>
          <div>:&nbsp;</div>
          <div *ngIf="solution?.name; else loader" class="val fw-600 w-300px">{{solution?.name}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
      <div class="right-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.SERVICE_DEFINITION_NAME' | transloco }}</div>
          <div>:&nbsp;</div>
          <div *ngIf="data || data?.name; else loader" class="val fw-600">{{getBlueprints?.name ? getBlueprints?.name : ('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="flex flex-row grid-flow-col">
      <div class="left-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.REGION' | transloco }}</div>
          <div>:&nbsp;</div>
          <div *ngIf="data || (data?.region || data?.regionPair); else loader" class="val fw-600">{{data?.region || data?.regionPair || ('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
      <div class="right-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_SUMMARY.VERSION' | transloco }}</div>:&nbsp;
          <div *ngIf="solutionVersion && solutionVersion?.version || solution?.name; else loader" class="val fw-600">{{solutionVersion && solutionVersion?.version? solutionVersion?.version : ('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="flex flex-row grid-flow-col">
      <div class="left-pane flex flex-col hide">
        <!-- <div class="label-text flex mt-24 flex flex-row">
          <div class="key">{{ 'INSTANCE_DETAILS.RELEASE_NOTES' | transloco }}</div>:&nbsp;
          <div class="val fw-600 flex flex-row view-release-notes">
            <ng-container *ngIf="solutionVersion; else loader">
              <mat-icon svgIcon="open_in_new" class="icon-sm mt-2 mr-10 cursor-pointer" (click)="navigateToUrl(solutionVersion?.releaseNotes)"></mat-icon>
              <a class="view-release-internal-link mat-body cursor-pointer fw-600" [href]="solutionVersion?.releaseNotes" target="_blank">{{'BLUEPRINT_SUMMARY.VIEW_RELEASE_NOTES' | transloco}}</a>
              <mat-icon *ngIf="'BLUEPRINT_SUMMARY.VIEW_RELEASE_NOTES'" (click)="onCopyId(solutionVersion?.releaseNotes)"  [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" class="copy-icon icon-md ml-10 cursor-pointer"></mat-icon>
            </ng-container>
          </div>
        </div> -->
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
      <div class="left-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.UPDATED_ON' | transloco }}</div>:&nbsp;
          <div *ngIf="data; else loader" class="val fw-600">{{data?.dateUpdated ? (data?.dateUpdated | date: 'dd MMM yyyy, HH:mm' + ' UTC') : ('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
      <div class="right-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.CREATED_ON' | transloco }}</div>:&nbsp;
          <div *ngIf="data; else loader" class="val fw-600">{{data?.dateCreated ? (data?.dateCreated | date: 'dd MMM yyyy, HH:mm' + ' UTC') : ('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="flex flex-row grid-flow-col">
      <div class="left-pane flex flex-col hide">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.ENVIRONMENT' | transloco }}</div>:&nbsp;
          <div *ngIf="data; else loader" class="val fw-600">{{data?.environment ? data?.environment : 'INSTANCE_STATUS.NA' | transloco}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>

    </div>
    <div class="flex flex-row grid-flow-col">
      <div class="left-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.CREATED_BY' | transloco }}</div>:&nbsp;
          <div *ngIf="data; else loader" class="val fw-600">{{ data?.createdBy ? data.createdBy : ('BLUEPRINT_SUMMARY.NA' | transloco) }}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
      <div class="right-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.OVERVIEW_MODIFIED_BY' | transloco }}</div>:&nbsp;
          <div *ngIf="data; else loader" class="val fw-600">{{ data?.modifiedBy ? data.modifiedBy : ('BLUEPRINT_SUMMARY.NA' | transloco) }}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="mat-headline fw-700 fs-18 instance-font mt-42">{{ 'INSTANCE_DETAILS.INSTANCE_DETAILS' | transloco }}</div>
  <mat-divider class="neutral-2 mt-12"></mat-divider>
  <div>
    <div class="flex flex-row grid-flow-col">
      <div class="left-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.INSTANCE_ID' | transloco }}</div>
          <div>:&nbsp;</div>
          <mat-icon *ngIf="data?.id" class="icon-sm w-18 mr-6 ml-8 mt-4 cursor-pointer" svgIcon="open_in_new" (click)="openUrl()"></mat-icon>
          <div *ngIf="data; else loader" class="overview-values fw-500 edit_hover_class">
            <a href="javascript:void(0);" (click)="openUrl()" class="no-underline" [matTooltip]="data?.id ? data?.id : ''"
              matTooltipPosition="above" matTooltipClass="mat-tooltip tooltip-inner id-tooltip above pt-8 pr-8 pb-8 pl-8 fs-16">{{data?.id ? data?.id : ('BLUEPRINT_SUMMARY.NA' | transloco)}}</a>
            <mat-icon *ngIf="data?.id" class="h-18 w-18 mr-6 copy-icon ml-4" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(data?.id)"></mat-icon>
          </div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
      <div class="right-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.RANDOM_SUFFIX' | transloco }}</div>
          <div>:&nbsp;</div>
          <div *ngIf="data; else loader" class="val fw-600 w-300px">{{data?.randomSuffix ? data?.randomSuffix : ('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="flex flex-row grid-flow-col">
      <div class="left-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.DEPLOYMENT_CLASS' | transloco }}</div>
          <div>:&nbsp;</div>
          <div *ngIf="data; else loader" class="val fw-600">{{data?.deploymentClass ? data?.deploymentClass : ('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
      <div class="right-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.DATA_ZONE' | transloco }}</div>
          <div>:&nbsp;</div>
          <div *ngIf="data; else loader" class="val fw-600 w-300px">{{data?.dataZone ? data?.dataZone : ('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="flex flex-row grid-flow-col">
      <div class="left-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.PRIMARY_CLOUD_REGION' | transloco }}</div>
          <div>:&nbsp;</div>
          <div *ngIf="data || (data?.primaryCloudRegion || data?.primaryRegion); else loader" class="val fw-600">{{data?.primaryCloudRegion || data?.primaryRegion || ('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
      <div class="right-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.SECONDARY_CLOUD_REGION' | transloco }}</div>
          <div>:&nbsp;</div>
          <div *ngIf="data && !hasSecondaryRegion; else showData" class="val fw-600 w-300px">{{('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
          <ng-template #showData>
            <div *ngIf="data || (data?.secondaryCloudRegion || data?.secondaryRegion); else loader" class="val fw-600 w-300px">{{data?.secondaryCloudRegion || data?.secondaryRegion || ('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
          </ng-template>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="flex flex-row grid-flow-col">
      <div class="left-pane flex flex-col hide">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.MANAGEMENT_TYPE' | transloco }}</div>
          <div>:&nbsp;</div>
          <div *ngIf="data; else loader" class="val fw-600">
            {{data?.managementType ? data?.managementType : ('BLUEPRINT_SUMMARY.NA' | transloco)}}
          </div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
      <div class="right-pane flex flex-col hide">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.EXTERNAL_ORIGINATION' | transloco }}</div>
          <div>:&nbsp;</div>
          <div class="val fw-600 w-300px">-</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="flex flex-row grid-flow-col">
      <div class="left-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.SERVICE_DEFINITION_NAME' | transloco }}</div>
          <div>:&nbsp;</div>
          <div *ngIf="getBlueprints; else loader" class="val fw-600">{{getBlueprints?.name ? getBlueprints?.name : ('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
      <div class="right-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.SERVICE_DEFINITION_ID' | transloco }}</div>
          <div>:&nbsp;</div>
          <div *ngIf="getBlueprints; else loader" class="val fw-600">{{getBlueprints?.id ? getBlueprints?.id : ('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="flex flex-row grid-flow-col">
      <div class="left-pane flex flex-col hide">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.DEPLOYMENT_ID' | transloco }}</div>
          <div>:&nbsp;</div>
          <div *ngIf="data?.id; else loader" class="val fw-600">{{data?.latestDeploymentId? data?.latestDeploymentId : '-'}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
      <div class="right-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.CONFIGURATION_ID' | transloco }}</div>
          <div>:&nbsp;</div>
          <div *ngIf="data; else loader" class="val fw-600 w-300px">{{data?.configurationId? data?.configurationId : ('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
      <div class="left-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.INSTANCE_TYPE' | transloco }}</div>
          <div>:&nbsp;</div>
          <div *ngIf="data; else loader" class="val fw-600">{{data?.type? data?.type : ('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="mat-headline fw-700 fs-18 instance-font mt-42">{{ 'INSTANCE_DETAILS.SOLUTION_DETAILS' | transloco }}</div>
  <mat-divider class="neutral-2 mt-12"></mat-divider>
  <div class="mb-24">
    <div class="flex flex-row grid-flow-col">
      <div class="left-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.SOLUTION_NAME' | transloco }}</div>
          <div>:&nbsp;</div>
          <div *ngIf="solution; else loader" class="val fw-600 w-300px">{{solution?.name ? solution?.name : ('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
      <div class="right-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.SOLUTION_ID' | transloco }}</div>
          <div>:&nbsp;</div>
          <mat-icon *ngIf="data?.solutionId" class="icon-sm w-18 mr-6 ml-8 mt-4 cursor-pointer" svgIcon="open_in_new" (click)="openUrlSolution(data?.solutionId)"></mat-icon>
          <div *ngIf="data; else loader" class="overview-values fw-500 edit_hover_class">
            <a href="javascript:void(0);" (click)="openUrlSolution(data?.solutionId)" [matTooltip]="data?.solutionId ? data?.solutionId : ''"
              matTooltipPosition="above" matTooltipClass="mat-tooltip tooltip-inner id-tooltip above pt-8 pr-8 pb-8 pl-8 fs-16" class="no-underline">{{data?.solutionId ? data?.solutionId : ('BLUEPRINT_SUMMARY.NA' | transloco)}}</a>
            <mat-icon *ngIf="data?.solutionId" class="h-18 w-18 mr-6 copy-icon ml-4" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(data?.solutionId)"></mat-icon>
          </div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="flex flex-row grid-flow-col">
      <div class="left-pane flex flex-col">
        <div class="label-text flex mt-24">
          <div class="key">{{ 'INSTANCE_DETAILS.SOLUTION_VERSION_ID' | transloco }}</div>
          <div>:&nbsp;</div>
          <mat-icon *ngIf="data?.solutionVersionId" class="icon-sm w-18 mr-6 ml-8 mt-4 cursor-pointer" svgIcon="open_in_new" (click)="openUrlSolutionVersion(data?.solutionId)"></mat-icon>
          <div *ngIf="data; else loader" class="overview-values fw-500 edit_hover_class">
            <a href="javascript:void(0);" (click)="openUrlSolutionVersion(data?.solutionId)" [matTooltip]="data?.solutionVersionId ? data?.solutionVersionId : ''"
              matTooltipPosition="above" matTooltipClass="mat-tooltip tooltip-inner id-tooltip above pt-8 pr-8 pb-8 pl-8 fs-16" class="no-underline">{{data?.solutionVersionId ? data?.solutionVersionId : ('BLUEPRINT_SUMMARY.NA' | transloco)}}</a>
            <mat-icon *ngIf="data?.solutionVersionId" class="h-18 w-18 mr-6 copy-icon ml-4" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(data?.solutionVersionId)"></mat-icon>
          </div>
        </div>
        <ng-template #loader>
          <div class="pl-6 skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
